import {beautifyLog, errorlog, getLastElementOr, isNotEmptyArray, onlyNotNull, showlog} from "../../../utils";
import {CustomInput, FormGroup, Input, Label} from "reactstrap";
import Select from "react-select";
import React, {useEffect, useState} from "react";
import {translate} from '../../../components/i18n/translate-function';
import ActionButton from "../../../components/save-button";
import {checkQuestionStatus, loadAnswers, loadProgress, savePerimeterQuestion} from "../../../business-logic/rating";
import "../../../style/index.css";
import {
  cloneOpenNodes,
  convertSIRatingSubQuestionTableToSubQuestionChild,
  getQuestionPath
} from "../../../business-logic/question-tree-manager";
import parse from "html-react-parser";

export function RenderQuestions(props) {

  const {
    id = 0,
    description = "",
    type = 1,
    attachmentType = 0,
    attachments = [],
    isOpen = true
  } = props.question

  const answers = props.question?.answers?.value || []
  let choiche = props.question?.choiche || []
  const evaluationId = props.evaluationId
  const isDisabled = props.isDisabled || false

  const [multiSelect, setMultiSelect] = useState([])
  const [singleInputSelect, setSingleInputSelect] = useState(type === 10 ? answers : [])
  // const [multiInputSelect, setMultiInputSelect] = useState(
  //   type === 11
  //     ? ((id === 18 || id === 19) ? (isNotEmptyArray(answers[1]) ? answers[1] : []) : answers)
  //     : []
  // )
  const [multiInputSelect, setMultiInputSelect] = useState(  type === 11 ? (isNotEmptyArray(answers) ? answers : []) : [])
  const [isDirty, setIsDirty] = useState(false)
  // const [body, setBody] = useState((id === 7 && isNotEmptyArray(answers)) ? answers[0] : answers)
  const [body, setBody] = useState(answers)
  const [waitingForSave, setWaitingForSave] = useState(false)
  const [selectedRadio, setSelectedRadio] = useState(type === 4 || type === 6 ? answers[0] : null)
  const [note, setNote] = useState(props.question?.answers?.note || "")

  useEffect(() => {
    // showlog('choiche', choiche);
    // setBody(answers)
    // setMultiInputSelect(answers)
    // setSingleInputSelect(answers)
  }, []);

// TODO AGGIUNGERE USE MEMO

  function checkQuestionAttachments(question, body) {
    try {
      showlog('checkQuestionAttachments()', question, body);

      if (question?.isRequiredAttachments === null) {
        if (question?.id === 21) {
          if (body?.[0] === true && !question.attachmentsNumber) return false
          else return true
        }
        else if (question?.id === 22) {
          if ((body?.includes(178) || body?.includes(179)) && !question.attachmentsNumber) return false
          else return true
        }
        else if (question?.id === 25) {
          if (body?.[0] === 157 && !question.attachmentsNumber) return false
          else return true
        }
        else if (question?.id === 26) {
          if (body?.[0] === 182 && !question.attachmentsNumber) return false
          else return true
        }
        else if (question?.id === 32) {
          if (body?.[0] === true && body?.[1]?.includes(163) && !question.attachmentsNumber) return false
          else return true
        }
        else if (question?.id === 33) {
          if (body?.[0] === true && body?.[1]?.includes(165) && !question.attachmentsNumber) return false
          else return true
        }
        else if (question?.id === 35) {
          if (body?.[0] === 167 && !question.attachmentsNumber) return false
          else return true
        }
      } else if (question?.isRequiredAttachments === true && !question.attachmentsNumber) {
        return false
      } else return true
    } catch (e) {
      errorlog("error in checkQuestionAttachments()", e)
    }
  }
  function canSave() {
    showlog('canSave()', body);
    return checkQuestionStatus(props.question, body)
    // return body?.filter(onlyNotNull)?.length === choiche?.length
  }

  function processBodyToSend(body) {
    showlog('processBodyToSend()', body);

    // let bodyToSend = [...body]
    // if (type === 4 || type === 5 || type === 6 || type === 7 || type === 8 || type === 9 || type === 10 || type === 11)
    //   bodyToSend = bodyToSend.filter(onlyNotNull)

    let bodyToSend = "***" + JSON.stringify(body)
    showlog('bodyToSend', bodyToSend);
    return bodyToSend
  }

  function _updateBody(index, value) {
    showlog('updateBody()', index, value);
    const updatedBody = [...body];
    updatedBody[index] = value || "";
    setIsDirty(true);
    setBody(updatedBody);
  }

  function updateBody(value, index) {
    showlog('updateBody()', value);
    let updatedBody = [...body];
    switch (type) {
      case 1: // campo input alfanumerico
      case 2: // campo input numerico
        if (!!value || value === 0 || value === '0')
          value = type === 2 ? parseFloat(value) : value;
        if (!!index || index === 0) updatedBody[index] = value;
        else updatedBody = [value]
        break;

      case 3: // campo input allegato
        break;

      case 4: // scelta singola
      case 8: // lista con selezione singola
      case 10: // lista con selezione singola con campo input
        if (id === 4) {
          setSelectedRadio(value.toString());
          updatedBody = [value.toString()]
        } else {
          setSelectedRadio(parseInt(value));
          updatedBody = [parseInt(value)]
        }
        break;

      case 6: // scelta singola con campi input
        if (index === 0) {
          updatedBody[index] = parseInt(value)
          setSelectedRadio(parseInt(value));
        } else if (!!index) updatedBody[index] = value
        break;

      case 5: // scelta multipla
        if (updatedBody.some(bId => parseInt(bId) === parseInt(value))) {
          updatedBody = updatedBody.filter(bId => parseInt(bId) !== parseInt(value))
        } else updatedBody.push(parseInt(value))
        break;

      case 9: // lista con selezione multipla
        updatedBody = (value || []).map(id => parseInt(id))
        break;

      case 7: // scelta multipla con campi input
        value = {...value, id: parseInt(value?.id || 0)}
        const existingIndex = updatedBody.findIndex(uBody => parseInt(uBody?.id) === parseInt(value?.id));
        if (existingIndex >= 0) updatedBody[existingIndex] = value
        else if (value?.id) updatedBody.push(value)
        break;

      case 11: // lista con selezione multipla con campo input
        // uso l'index in questo tipo di domanda per gestire la domanda 18 e 19
        if (!!index || index === 0) {
          updatedBody[index] = value.map(item => ({
            ...item,
            id: parseInt(item?.id || 0)
          }));
        } else {
          updatedBody = value.map(item => ({
            ...item,
            id: parseInt(item?.id || 0)
          }));
        }
        break;

    }

    setBody(updatedBody);
    setIsDirty(true);
  }

  // Questa funzione viene usata in particolar modo per risolvere un problema di visualizzazione;
  // Quando si hanno le liste multiselect, con i campi di input; Se ad esempio si hanno 3 elementi con i valori inseriti
  // e dal componente <Select> viene eliminato uno di questi elementi, il componente <Input> non si aggiorna
  // correttamente e sembra come che venga eliminato sempre l'ultimo elemento, anche se dai log si vede correttamente
  // che viene eliminato l'elemento giusto.
  // La soluzione sarebbe quella di passare uno state, che si aggiorna ad ogni onChange, nella prop value del
  // componente <Input>, ma nelle attuali condizioni delle domande di perimetro, richiederebbe troppo tempo che
  // attualmente non abbiamo

  function resetBody(value) {
    Promise.resolve()
      .then(() => setBody())
      .then(() => setBody(value))
  }

  let content;

  function TextInputComponent(props) {
    return (
      <Input
        type={type === 2 ? "number" : undefined}
        row={32}
        name={"reason-" + id}
        id={"reason-" + id}
        // placeholder={translate("Insert") + " " + ch}
        className={type === 2 ? "perimeter-question-input-field" : "perimeter-large-question-input-field"}
        defaultValue={body[props?.index || 0]}
        required
        onBlur={(blurEvent) => {
          let value = blurEvent?.target?.value || null;
          // if (value && type === 2) value = parseFloat(value);
          // showlog('value', value);
          updateBody(value, props?.index)
        }}
        disabled={isDisabled}
      />
    )
  }

  /*   ---   CAMPO INPUT ALFANUMERICO & CAMPO INPUT NUMERICO   ---   */
  if (type === 1 || type === 2) {


    content = (
      Array.isArray(choiche) && choiche.length > 0 ? (
        (choiche || []).map((ch, index) => {
          return (
            <div key={index}>
              {
                choiche.length > 1 &&
                <Label for={"reason-" + id}>{ch?.description}</Label>
              }
              <TextInputComponent index={index}/>
            </div>
          )
        })
      ) : <TextInputComponent/>
    )
  }

  /*   ---   CAMPO INPUT ALLEAGTO   ---   */
  else if (type === 3) {
    content = (
      (choiche || []).map((ch, index) => {
        return <div/>
      })
    )
  }

  /*   ---   SCELTA SINGOLA   ---   */
  else if (type === 4) {
    content = (
      (choiche || []).map((ch, index) => {
        return (
          <FormGroup key={index + (new Date().getTime())} check>
            <Input
              type="radio"
              name={"radio-input"}
              value={ch?.id || 0}
              onClick={(event) => updateBody(ch?.id)}
              defaultChecked={parseInt(body[0]) === parseInt(ch?.id)}
              // checked={parseInt(body[0]) === parseInt(ch?.id)}
              disabled={isDisabled}
            />
            <Label check>{ch?.description}</Label>
          </FormGroup>
        )
      })
    )
    content = (

      (choiche || []).map((ch, index) => (
        <div className={"small-margin-left"}>
          <Input
            type="radio"
            value={ch?.id || 0}
            onClick={() => {
              updateBody(ch?.id, 0)
            }}
            checked={parseInt(selectedRadio) === parseInt(ch?.id)}
            disabled={isDisabled}
          />
          <Label>{ch?.description}</Label>
        </div>
      ))
    )
  }

  /*   ---   SCELTA MULTIPLA   ---   */
  else if (type === 5) {
    content = (
      (choiche || []).map((ch, index) => {

        return (
          <div className={"small-margin-left"}>
            <Input
              type="checkbox"
              name={"checkbox-input"}
              value={ch?.id || 0}
              onClick={(event) => updateBody(ch?.id, index)}
              // defaultValue={body.some(bId => parseInt(bId) === parseInt(ch?.id))}
              defaultChecked={body.some(bId => parseInt(bId) === parseInt(ch?.id))}
              disabled={isDisabled}
            />
            <Label check>{ch?.description}</Label>
          </div>
        )
      })
    )
  }

  /*   ---   SCELTA SINGOLA CON CAMPI INPUT   ---   */
  else if (type === 6) {
    //
    //
    // content = (
    //   <div>
    //     <FormGroup>
    //       {
    //         (choiche || []).map((ch, index) => {
    //           return (
    //             <CustomInput
    //               key={`radio-${ch.id}`}
    //               type="radio"
    //               name={"radio-input"}
    //               id={`radio-input-${ch.id}`}
    //               label={ch?.description}
    //               onChange={() => {
    //                 setSelectedRadio(ch?.id)
    //                 updateBody(ch?.id, 0)
    //               }}
    //               checked={index === 0}
    //             />
    //           )
    //         })
    //       }
    //     </FormGroup>
    //     <TextInputComponent index={0}/>
    //   </div>
    // )
    //
    // content = (
    //   <FormGroup>
    //
    //     <CustomInput
    //       key={`radio-${100}`}
    //       type="radio"
    //       name={"radio-input"}
    //       id={`radio-input-${100}`}
    //       label={"AAAA"}
    //       checked={true}
    //     />
    //     <CustomInput
    //       key={`radio-${101}`}
    //       type="radio"
    //       name={"radio-input"}
    //       id={`radio-input-${101}`}
    //       label={"BBBB"}
    //       checked={false}
    //     />
    //   </FormGroup>
    // )
    // content = (
    //   <FormGroup>
    //     {
    //       (choiche || []).map((ch, index) => (
    //         <div>
    //           <Input
    //             type="radio"
    //             value={ch?.id || 0}
    //             // onClick={() => handleOptionChange(option)}
    //             checked={parseInt(body[1]) === parseInt(ch?.id)}
    //           />
    //           <Label>{ch?.description}</Label>
    //         </div>
    //       ))
    //     }
    //   </FormGroup>
    // )
    content = (
      <FormGroup>
        {
          (choiche || []).map((ch, index) => (
            <div>
              <Input
                type="radio"
                value={ch?.id || 0}
                onClick={() => {
                  updateBody(ch?.id, 0)
                }}
                checked={parseInt(selectedRadio) === parseInt(ch?.id)}
                disabled={isDisabled}
              />
              <Label>{ch?.description}</Label>
            </div>
          ))
        }
        <TextInputComponent index={1}/>
      </FormGroup>
    )
  }

  /*   ---   SCELTA MULTIPLA CON CAMPI INPUT   ---   */
  else if (type === 7) {
    content = (
      <div/>
    )
  }

  /*   ---   LISTA CON SELEZIONE SINGOLA   ---   */
  else if (type === 8) {
    content = (
      <div>
        <Select
          className={"react-select perimeter-question-select "}
          classNamePrefix="react-select"
          name="perimeter-question-multi-select"
          id="perimeter-question-multi-select"
          onChange={(element) => updateBody(element.value)}
          options={choiche?.map((ch) => ({label: ch.description, value: ch.id?.toString()}))}
          value={body?.map(choiceId => {
            let ch = choiche.find(ch => ch.id?.toString() === choiceId?.toString())
            return {label: ch?.description, value: ch?.id}
          })}
          placeholder={<span className={"select-placeholder"}>{translate("Select")}</span>}
          noOptionsMessage={() => translate("No Element")}
          required
          isDisabled={isDisabled}
        />
      </div>
    )
  }

  /*   ---   LISTA CON SELEZIONE MULTIPLA   ---   */
  else if (type === 9 && id !== 7) {
    content = (
      <div>
        <Select
          className={"react-select perimeter-question-select"}
          classNamePrefix="react-select"
          name="perimeter-question-multi-select"
          id="perimeter-question-multi-select"
          onChange={(elements) => updateBody(elements?.map(el => el.value) || [])}
          options={choiche?.map((ch) => ({label: ch.description, value: parseInt(ch.id)}))}
          value={body?.filter(onlyNotNull)?.map(choiceId => {
            let ch = choiche.find(ch => parseInt(ch.id) === parseInt(choiceId))
            return {label: ch?.description, value: ch?.id}
          })}
          placeholder={<span className={"select-placeholder"}>{translate("Select")}</span>}
          noOptionsMessage={() => translate("No Element")}
          required
          isMulti
          closeMenuOnSelect={false}
          isDisabled={isDisabled}
        />
      </div>
    )
  }

  /*   ---   LISTA CON SELEZIONE SINGOLA CON CAMPI INPUT   ---   */
  else if (type === 10) {
    content = (
      <div>
        <Select
          className={"react-select perimeter-question-select"}
          classNamePrefix="react-select"
          name="perimeter-question-multi-select"
          id="perimeter-question-multi-select"
          onChange={(element) => setSingleInputSelect({id: element.value, description: element.label})}
          options={choiche?.map((ch) => ({label: ch.description, value: parseInt(ch.id)}))}
          value={body?.filter(onlyNotNull)?.map(choiceId => {
            let ch = choiche.find(ch => parseInt(ch.id) === parseInt(choiceId))
            return {label: ch.description, value: ch.id}
          })}
          placeholder={<span className={"select-placeholder"}>{translate("Select")}</span>}
          noOptionsMessage={() => translate("No Element")}
          required
          isDisabled={isDisabled}
        />
        <div className={"perimeter-question-list-inputs"}>
          {
            // singleInputSelect = {description: string, id: number, value: string}[]
            !!singleInputSelect && (
              <div>
                <Label for={"reason-" + id}>{singleInputSelect?.description}</Label>
                <Input
                  type="textarea"
                  row={32}
                  name={"reason-" + id}
                  id={"reason-" + id}
                  // placeholder={translate("Insert") + " " + singleInputSelect?.description}
                  className={""}
                  defaultValue={singleInputSelect?.value}
                  required
                  onBlur={blurEvent => {
                    setSingleInputSelect({...singleInputSelect, value: blurEvent?.target?.value || ""});
                    updateBody(singleInputSelect)
                  }}
                  disabled={isDisabled}
                />
              </div>
            )
          }
        </div>
      </div>
    )
  }

  /*   ---   LISTA CON SELEZIONE MULTIPLA CON CAMPI INPUT   ---   */
  else if (type === 11) {


    content = (
      <div>
        <Select
          className={"react-select perimeter-question-select"}
          classNamePrefix="react-select"
          name="perimeter-question-multi-select"
          id="perimeter-question-multi-select"
          onChange={(elements) => setMultiInputSelect(elements?.map(el => ({
            id: el.value,
            description: el.label,
            value: multiInputSelect?.find(mi => parseInt(mi?.id) === parseInt(el.value))?.value || ""
          })) || [])}
          options={choiche?.map((ch) => ({label: ch.description, value: parseInt(ch.id)}))}
          value={(multiInputSelect || [])?.map(selectedChoiche => {
            let ch = choiche.find(ch => parseInt(ch?.id) === parseInt(selectedChoiche?.id))
            return {label: ch?.description, value: ch?.id}
          })}
          placeholder={<span className={"select-placeholder"}>{translate("Select")}</span>}
          noOptionsMessage={() => translate("No Element")}
          required
          isMulti
          closeMenuOnSelect={false}
          isDisabled={isDisabled}
        />
        <div className={"perimeter-question-list-inputs"}>
          {
            // multiInputSelect = {description: string, id: number, value: string}[]
            (multiInputSelect || [])?.map((element, index) => {
              return (
                <div>
                  <Label for={"reason-" + id}>{element?.description}</Label>
                  <Input
                    type={(id === 17) ? "number" : "textarea"}
                    row={32}
                    name={"reason-" + id}
                    id={"reason-" + id}
                    // placeholder={translate("Insert") + " " + element?.description}
                    className={""}
                    defaultValue={element?.value}
                    required
                    onBlur={blurEvent => {
                      const updatedMultiInputSelect = [...multiInputSelect];
                      updatedMultiInputSelect[index] = {
                        ...updatedMultiInputSelect[index],
                        value: blurEvent?.target?.value || ""
                      };
                      setMultiInputSelect(prevState => updatedMultiInputSelect);
                      updateBody(updatedMultiInputSelect, id === 18 || id === 19 ? 1 : undefined)
                    }}
                    disabled={isDisabled}
                  />
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  // Per gestire in fretta
  if (id === 7) {

    const italianRegions = props.italianRegions || []
    content = (
      <div>
        <div>
          <Select
            className={"react-select perimeter-question-select"}
            classNamePrefix="react-select"
            name="perimeter-question-multi-select"
            id="perimeter-question-multi-select"
            onChange={(elements) => {
              showlog('elements', elements);
              const isItalySelected = elements?.some(el => parseInt(el.value) === 86);

              setBody({
                ...body,
                nations: (elements?.map(el => parseInt(el.value)) || []),
                regions: isItalySelected ? body?.regions : []
              })
              setIsDirty(true)
            }}
            options={choiche?.map((ch) => ({label: ch.description, value: parseInt(ch.id)}))}
            value={body?.nations?.filter(onlyNotNull)?.map(choiceId => {
              let ch = choiche.find(ch => parseInt(ch.id) === parseInt(choiceId))
              return {label: ch?.description, value: ch?.id}
            })}
            placeholder={<span className={"select-placeholder"}>{translate("Select")}</span>}
            noOptionsMessage={() => translate("No Element")}
            required
            isMulti
            closeMenuOnSelect={false}
            isDisabled={isDisabled}
          />
        </div>
        <div>
          {
            (body?.nations?.includes(86) || body?.nations?.includes('86')) && ( // "Italia" selezionata
              <div className={"italian-region-select-label"}>
                <Label>{translate("ItalianRegions")}</Label>
                <Select
                  className={"react-select perimeter-question-select"}
                  classNamePrefix="react-select"
                  name="perimeter-question-multi-select-italy"
                  id="perimeter-question-multi-select-italy"
                  onChange={(elements) => {
                    setBody([{...body, regions: elements?.map(el => parseInt(el.value)) || []}])
                    setIsDirty(true)
                  }}
                  options={italianRegions?.map((ch) => ({label: ch.description, value: parseInt(ch.id)}))}
                  value={body?.regions?.filter(onlyNotNull)?.map(choiceId => {
                    let ch = choiche.find(ch => parseInt(ch.id) === parseInt(choiceId))
                    return {label: ch?.description, value: ch?.id}
                  })}
                  placeholder={<span className={"select-placeholder"}>{translate("Select")}</span>}
                  noOptionsMessage={() => translate("No Element")}
                  required
                  isMulti
                  closeMenuOnSelect={false}
                  isDisabled={isDisabled}
                />
              </div>
            )
          }
        </div>
      </div>
    )
  }

  // Per gestire in fretta
  if (id === 9) {
    content = (
      <FormGroup>
        <div>
          <Select
            className={"react-select perimeter-question-select"}
            classNamePrefix="react-select"
            name="perimeter-question-multi-select"
            id="perimeter-question-multi-select"
            onChange={(elements) => {
              const updatedMultiInputSelect = elements?.map(el => ({
                id: el.value,
                description: el.label,
                value: body?.Country?.find(mi => parseInt(mi?.id) === parseInt(el.value))?.value || [0, 0]
              })) || []
              // setMultiInputSelect(updatedMultiInputSelect)
              // setBody([body[0], updatedMultiInputSelect])
              // setBody({...body, Country: updatedMultiInputSelect})
              resetBody({...body, Country: updatedMultiInputSelect})
              setIsDirty(true)
            }}
            options={choiche?.map((ch) => ({label: ch.description, value: parseFloat(ch.id)}))}
            value={body?.Country?.map(selectedChoiche => {
              let ch = choiche.find(ch => parseInt(ch?.id) === parseInt(selectedChoiche?.id))
              return {label: ch?.description, value: ch?.id}
            })}
            placeholder={<span className={"select-placeholder"}>{translate("Select")}</span>}
            noOptionsMessage={() => translate("No Element")}
            required
            isMulti
            closeMenuOnSelect={false}
            isDisabled={isDisabled}
          />
          <div className={"perimeter-question-list-inputs"}>
            {
              // multiInputSelect = {description: string, id: number, value: string}[]
              body?.Country?.map((element, index) => {
                return (
                  <div key={"id-" + id + "-" + index}>
                    <Label for={"reason-" + id} className={"small-margin-top"}>{element?.description}</Label>
                    <div className={"small-margin-left space-between"}>
                      <div>
                        <Label for={"reason-" + id}>{translate("PermanentContracts")}</Label>
                        <Input
                          type={"number"}
                          name={"reason-per-" + id}
                          id={"reason-per-" + id}
                          // placeholder={translate("Insert") + " " + element?.description}
                          className={""}
                          defaultValue={parseFloat(element?.value[0]) || 0}
                          required
                          onBlur={blurEvent => {
                            const updatedMultiInputSelect = [...body?.Country];
                            updatedMultiInputSelect[index] = {
                              ...updatedMultiInputSelect[index],
                              value: [parseFloat(blurEvent?.target?.value) || 0, updatedMultiInputSelect[index]?.value[1]]
                            };
                            // setBody([body[0], updatedMultiInputSelect])
                            setBody({...body, Country: updatedMultiInputSelect})
                            setIsDirty(true)
                          }}
                          disabled={isDisabled}
                        />
                      </div>
                      <div className={"small-margin-left"}>

                        <Label for={"reason-" + id}>{translate("TemporaryContracts")}</Label>
                        <Input
                          type={"number"}
                          name={"reason-tem-" + id}
                          id={"reason-tem-" + id}
                          // placeholder={translate("Insert") + " " + element?.description}
                          className={""}
                          defaultValue={parseFloat(element?.value[1]) || 0}
                          required
                          onBlur={blurEvent => {
                            const updatedMultiInputSelect = [...body?.Country];
                            updatedMultiInputSelect[index] = {
                              ...updatedMultiInputSelect[index],
                              value: [updatedMultiInputSelect[index]?.value[0], parseFloat(blurEvent?.target?.value) || 0]
                            };
                            // setBody([body[0], updatedMultiInputSelect])
                            setBody({...body, Country: updatedMultiInputSelect})
                            setIsDirty(true)
                          }}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </FormGroup>
    )
  }

  // Per gestire in fretta
  // if (id === 10) {
  //   content = (
  //     <FormGroup>
  //       <div>
  //         <Input
  //           type="radio"
  //           value={false}
  //           onClick={() => {
  //             setBody([false, null])
  //             setIsDirty(true)
  //           }}
  //           checked={body[0] === false}
  //           disabled={isDisabled}
  //         />
  //         <Label>{translate("Undetectable")}</Label>
  //       </div>
  //       <div>
  //         <Input
  //           type="radio"
  //           value={true}
  //           onClick={() => {
  //             setBody([true, (body[1] || null)])
  //             setIsDirty(true)
  //           }}
  //           checked={body[0]}
  //           disabled={isDisabled}
  //         />
  //         <Label>{translate("Detectable")}</Label>
  //       </div>
  //       {
  //         !!body[0] && (
  //           <div>
  //             <Label for={"reason-0" + id}>{choiche?.[0]?.description}</Label>
  //             <Input
  //               type={"number"}
  //               name={"reason-0" + id}
  //               id={"reason-0" + id}
  //               defaultValue={body[1]?.[0]}
  //               onBlur={(blurEvent) => {
  //                 let value = blurEvent?.target?.value || null;
  //                 setBody([true, [(parseFloat(value) || 0), body[1]?.[1] || 0]])
  //                 setIsDirty(true)
  //               }}
  //               disabled={isDisabled}
  //             />
  //             <Label for={"reason-1" + id}>{choiche?.[1]?.description}</Label>
  //             <Input
  //               type={"number"}
  //               name={"reason-1" + id}
  //               id={"reason-1" + id}
  //               defaultValue={body[1]?.[1]}
  //               onBlur={(blurEvent) => {
  //                 let value = blurEvent?.target?.value || null;
  //                 setBody([true, [body[1]?.[0] || 0, (parseFloat(value) || 0)]])
  //                 setIsDirty(true)
  //               }}
  //               disabled={isDisabled}
  //             />
  //           </div>
  //         )
  //       }
  //     </FormGroup>
  //   )
  // }

  // if (id === 11) {
  //   content = (
  //     <FormGroup>
  //       <div>
  //         <Input
  //           type="radio"
  //           value={false}
  //           onClick={() => {
  //             setBody([false, []])
  //             setIsDirty(true)
  //           }}
  //           checked={body[0] === false}
  //           disabled={isDisabled}
  //         />
  //         <Label>{translate("Undetectable")}</Label>
  //       </div>
  //       <div>
  //         <Input
  //           type="radio"
  //           value={true}
  //           onClick={() => {
  //             setBody([true, (body[1] || 0)])
  //             setIsDirty(true)
  //           }}
  //           checked={body[0]}
  //           disabled={isDisabled}
  //         />
  //         <Label>{translate("Detectable")}</Label>
  //       </div>
  //       {
  //         !!body[0] && (
  //           <div>
  //             <Label for={"reason-0" + id}>{choiche?.[0]?.description}</Label>
  //             <Input
  //               type={"number"}
  //               name={"reason-0" + id}
  //               id={"reason-0" + id}
  //               defaultValue={body[1]?.[0] || ""}
  //               onBlur={(blurEvent) => {
  //                 let value = blurEvent?.target?.value || null;
  //                 setBody([true, [(parseFloat(value) || 0), body[1]?.[1] || 0]])
  //                 setIsDirty(true)
  //               }}
  //               disabled={isDisabled}
  //             />
  //             <Label for={"reason-1" + id}>{choiche?.[1]?.description}</Label>
  //             <Input
  //               type={"number"}
  //               name={"reason-1" + id}
  //               id={"reason-1" + id}
  //               defaultValue={body[1]?.[1] || ""}
  //               onBlur={(blurEvent) => {
  //                 let value = blurEvent?.target?.value || null;
  //                 setBody([true, [body[1]?.[0] || 0, (parseFloat(value) || 0)]])
  //                 setIsDirty(true)
  //               }}
  //               disabled={isDisabled}
  //             />
  //           </div>
  //         )
  //       }
  //     </FormGroup>
  //   )
  // }

  // Per gestire in fretta
  if (id === 12) {
    content = (
      <FormGroup>

        <div>
          <Label>{translate("CompanyBusinessDescription")}</Label>
          <Input
            name={"reason-0" + id}
            id={"reason-0" + id}
            className={"perimeter-large-question-input-field"}
            defaultValue={body[1] || ""}
            onBlur={(blurEvent) => {
              let value = blurEvent?.target?.value || null;
              setBody([true, value])
              setIsDirty(true)
            }}
            disabled={isDisabled}
          />
        </div>

        <br/>
        <p>{translate("OnlineSales")}</p>
        <div className={"margin-left"}>

          <div>
            <Input
              type="radio"
              value={false}
              onClick={() => {
                setBody([false, body[1] || ""])
                setIsDirty(true)
              }}
              checked={body[0] === false}
              disabled={isDisabled}
            />
            <Label>{translate("No")}</Label>
          </div>
          <div>
            <Input
              type="radio"
              value={true}
              onClick={() => {
                setBody([true, (body[1] || "")])
                setIsDirty(true)
              }}
              checked={body[0]}
              disabled={isDisabled}
            />
            <Label>{translate("Yes")}</Label>
          </div>
        </div>

      </FormGroup>
    )
  }

  if (id === 16) {
    const selectedChoices = choiche.filter(ch => (body[1] || []).includes(parseInt(ch.id)));
    const totalSelected = selectedChoices.length;

    const euCount = selectedChoices.filter(ch => ch.isEu).length;
    const euPercentage = totalSelected ? Math.round((euCount / totalSelected) * 100) : 0;
    const extraEuPercentage = totalSelected ? Math.round(((totalSelected - euCount) / totalSelected) * 100) : 0;

    content = (
      <FormGroup>
        <div>
          <Input
            type="radio"
            value={false}
            onClick={() => {
              setBody([false, []])
              setIsDirty(true)
            }}
            checked={body[0] === false}
            disabled={isDisabled}
          />
          <Label>{translate("Undetectable")}</Label>
        </div>
        <div>
          <Input
            type="radio"
            value={true}
            onClick={() => {
              setBody([true, body[1] || null])
              setIsDirty(true)
            }}
            checked={body[0]}
            disabled={isDisabled}
          />
          <Label>{translate("Detectable")}</Label>
        </div>
        {
          !!body[0] &&
          <div className={"space-between"}>
            <div>
              <Select
                className={"react-select perimeter-question-select"}
                classNamePrefix="react-select"
                name="perimeter-question-multi-select"
                id="perimeter-question-multi-select"
                onChange={(elements) => {
                  setBody([true, (elements?.map(el => parseFloat(el.value)) || [])])
                  setIsDirty(true)
                }}
                options={choiche?.map((ch) => ({label: ch.description, value: parseInt(ch.id)}))}
                value={body?.[1]?.filter(onlyNotNull)?.map(choiceId => {
                  let ch = choiche.find(ch => parseInt(ch.id) === parseInt(choiceId))
                  return {label: ch?.description, value: parseFloat(ch?.id)}
                })}
                placeholder={<span className={"select-placeholder"}>{translate("Select")}</span>}
                noOptionsMessage={() => translate("No Element")}
                required
                isMulti
                closeMenuOnSelect={false}
                isDisabled={isDisabled}
              />
            </div>
            <div style={{marginLeft: "20px"}}>
              <p>{translate("UEPercentage")}: {euPercentage}%</p>
              <p>{translate("ExtraUEPercentage")}: {extraEuPercentage}%</p>
            </div>
          </div>
        }
      </FormGroup>
    )
  }

  // Per gestire in fretta
  // if (id === 17) {
  //
  //   content = (
  //     <FormGroup>
  //       <div>
  //         <Input
  //           type="radio"
  //           value={false}
  //           onClick={() => {
  //             setBody([false, null])
  //             setIsDirty(true)
  //           }}
  //           checked={!body[0]}
  //           disabled={isDisabled}
  //         />
  //         <Label>{translate("Undetectable")}</Label>
  //       </div>
  //       <div>
  //         <Input
  //           type="radio"
  //           value={true}
  //           onClick={() => {
  //             setBody([true, body[1] || null])
  //             setIsDirty(true)
  //           }}
  //           checked={body[0]}
  //           disabled={isDisabled}
  //         />
  //         <Label>{translate("Detectable")}</Label>
  //       </div>
  //       {
  //         !!body[0] &&
  //         <div>
  //           <Select
  //             className={"react-select perimeter-question-select"}
  //             classNamePrefix="react-select"
  //             name="perimeter-question-multi-select"
  //             id="perimeter-question-multi-select"
  //             onChange={(elements) => {
  //               setBody([
  //                 true,
  //                 elements?.map(el => ({
  //                   id: parseFloat(el.value),
  //                   description: el.label,
  //                   value: parseFloat(body?.[1]?.find(mi => parseFloat(mi?.id) === parseFloat(el.value))?.value || 0) || ""
  //                 })) || []])
  //               setIsDirty(true)
  //             }}
  //             options={choiche?.map((ch) => ({label: ch.description, value: parseFloat(ch.id)}))}
  //             value={body?.[1]?.map(selectedChoiche => {
  //               let ch = choiche.find(ch => parseFloat(ch?.id) === parseFloat(selectedChoiche?.id))
  //               return {label: ch?.description, value: ch?.id}
  //             })}
  //             placeholder={<span className={"select-placeholder"}>{translate("Select")}</span>}
  //             noOptionsMessage={() => translate("No Element")}
  //             required
  //             isMulti
  //             closeMenuOnSelect={false}
  //             isDisabled={isDisabled}
  //           />
  //           <div className={"perimeter-question-list-inputs"}>
  //             {
  //               // multiInputSelect = {description: string, id: number, value: string}[]
  //               body?.[1]?.map((element, index) => {
  //                 return (
  //                   <div>
  //                     <Label for={"reason-" + id}>{element?.description}</Label>
  //                     <Input
  //                       type={"number"}
  //                       row={32}
  //                       name={"reason-" + id}
  //                       id={"reason-" + id}
  //                       // placeholder={translate("Insert") + " " + element?.description}
  //                       className={""}
  //                       defaultValue={element?.value}
  //                       required
  //                       onBlur={blurEvent => {
  //                         const updatedMultiInputSelect = [...body[1]];
  //                         updatedMultiInputSelect[index] = {
  //                           ...updatedMultiInputSelect[index],
  //                           value: parseFloat(blurEvent?.target?.value || 0)
  //                         };
  //                         // setMultiInputSelect(prevState => updatedMultiInputSelect);
  //                         setBody([true, updatedMultiInputSelect])
  //                         setIsDirty(true)
  //                       }}
  //                       disabled={isDisabled}
  //                     />
  //                   </div>
  //                 )
  //               })
  //             }
  //           </div>
  //         </div>
  //       }
  //     </FormGroup>
  //   )
  // }

  // Per gestire in fretta
  if (id === 18 || id === 19) {
    content = (
      <FormGroup>
        <div>
          <Input
            type="radio"
            value={false}
            onClick={() => {
              setBody({...body, Detectable: false, Country: []})
              setIsDirty(true)
            }}
            checked={body?.Detectable === false}
            disabled={isDisabled}
          />
          <Label>{translate("No")}</Label>
        </div>
        <div>
          <Input
            type="radio"
            value={true}
            onClick={() => {
              setBody({...body, Detectable: true})
              setIsDirty(true)
            }}
            checked={body?.Detectable}
            disabled={isDisabled}
          />
          <Label>{translate("Yes")}</Label>
        </div>
        {
          !!body?.Detectable && (
            <div>
              <Select
                className={"react-select perimeter-question-select"}
                classNamePrefix="react-select"
                name="perimeter-question-multi-select"
                id="perimeter-question-multi-select"
                onChange={(elements) => {
                  resetBody({
                    ...body,
                    Country: elements?.map(el => ({
                      id: parseFloat(el.value),
                      description: el.label,
                      value: parseFloat(body?.Country?.find(mi => parseFloat(mi?.id) === parseFloat(el.value))?.value || 0) || ""
                    })) || []
                  })
                  // setBody({
                  //   ...body,
                  //   Country: elements?.map(el => ({
                  //     id: parseFloat(el.value),
                  //     description: el.label,
                  //     value: parseFloat(body?.Country?.find(mi => parseFloat(mi?.id) === parseFloat(el.value))?.value || 0) || ""
                  //   })) || []
                  // })
                  // setBody([
                  //   true,
                  //   elements?.map(el => ({
                  //     id: parseFloat(el.value),
                  //     description: el.label,
                  //     value: parseFloat(body?.[1]?.find(mi => parseFloat(mi?.id) === parseFloat(el.value))?.value || 0) || ""
                  //   })) || []])
                  setIsDirty(true)
                }}
                options={choiche?.map((ch) => ({label: ch.description, value: parseFloat(ch.id)}))}
                value={body?.Country?.map(selectedChoiche => {
                  let ch = choiche.find(ch => parseFloat(ch?.id) === parseFloat(selectedChoiche?.id))
                  return {label: ch?.description, value: ch?.id}
                })}
                placeholder={<span className={"select-placeholder"}>{translate("Select")}</span>}
                noOptionsMessage={() => translate("No Element")}
                required
                isMulti
                closeMenuOnSelect={false}
                isDisabled={isDisabled}
              />
              <div className={"perimeter-question-list-inputs"}>
                {
                  // multiInputSelect = {description: string, id: number, value: string}[]
                  body?.Country?.map((element, index) => {
                    return (
                      <div>
                        <Label for={"reason-" + id}>{element?.description}</Label>
                        <Input
                          type={"number"}
                          row={32}
                          name={"reason-" + id}
                          id={"reason-" + id}
                          // placeholder={translate("Insert") + " " + element?.description}
                          className={""}
                          defaultValue={element?.value}
                          required
                          onBlur={blurEvent => {
                            const updatedMultiInputSelect = [...body?.Country];
                            updatedMultiInputSelect[index] = {
                              ...updatedMultiInputSelect[index],
                              value: parseFloat(blurEvent?.target?.value || 0)
                            };
                            // setMultiInputSelect(prevState => updatedMultiInputSelect);
                            // setBody([true, updatedMultiInputSelect])
                            setBody({...body, Country: updatedMultiInputSelect})
                            setIsDirty(true)
                          }}
                          disabled={isDisabled}
                        />
                      </div>
                    )
                  })
                }
              </div>
            </div>
          )
        }
      </FormGroup>
    )
  }

  // Per gestire in fretta
  if (id === 21) {

    content = (
      <FormGroup>
        <div>
          <Input
            type="radio"
            value={false}
            onClick={() => {
              setBody([false, []])
              setIsDirty(true)
            }}
            checked={body?.[0] === false}
            disabled={isDisabled}
          />
          <Label>{translate("No")}</Label>
        </div>
        <div>
          <Input
            type="radio"
            value={true}
            onClick={() => {
              setBody([true, body?.[1]])
              setIsDirty(true)
            }}
            checked={!!body?.[0]}
            disabled={isDisabled}
          />
          <Label>{translate("Yes")}</Label>
        </div>
        {
          !!body?.[0] && (
            <Select
              className={"react-select perimeter-question-select"}
              classNamePrefix="react-select"
              name="perimeter-question-multi-select"
              id="perimeter-question-multi-select"
              onChange={(elements) => {
                setBody([true, (elements?.map(el => el.value) || [])])
                setIsDirty(true)
              }}
              options={choiche?.map((ch) => ({label: ch.description, value: parseFloat(ch.id)}))}
              value={body?.[1]?.filter(onlyNotNull)?.map(choiceId => {
                let ch = choiche.find(ch => parseInt(ch.id) === parseInt(choiceId))
                return {label: ch?.description, value: parseFloat(ch?.id)}
              })}
              placeholder={<span className={"select-placeholder"}>{translate("Select")}</span>}
              noOptionsMessage={() => translate("No Element")}
              required
              isMulti
              closeMenuOnSelect={false}
              isDisabled={isDisabled}
            />
          )
        }
      </FormGroup>
    )
  }

  // Per gestire in fretta
  if (id === 24) {
    content = (
      <FormGroup>
        <div>
          <Input
            type="radio"
            value={false}
            onClick={() => {
              setBody([false, null])
              setIsDirty(true)
            }}
            checked={body[0] === false}
            disabled={isDisabled}
          />
          <Label>{translate("No")}</Label>
        </div>
        <div>
          <Input
            type="radio"
            value={true}
            onClick={() => {
              setBody([true, (body[1] || 0)])
              setIsDirty(true)
            }}
            checked={body[0]}
            disabled={isDisabled}
          />
          <Label>{translate("Yes")}</Label>
        </div>
        {
          !!body[0] && (
            <Input
              type={"number"}
              name={"reason-" + id}
              id={"reason-" + id}
              defaultValue={body[1] || 0}
              onBlur={(blurEvent) => {
                let value = blurEvent?.target?.value || null;
                setBody([true, parseFloat(value)])
                setIsDirty(true)
              }}
              disabled={isDisabled}
            />
          )
        }
      </FormGroup>
    )
  }

  // Per gestire in fretta
  if (id === 31) {
    content = (
      <FormGroup>
        <div>
          <Input
            type="radio"
            value={false}
            id={"reason-0-" + id}
            onClick={() => {
              setBody([false, null])
              setIsDirty(true)
            }}
            checked={body[0] === false}
            disabled={isDisabled}
          />
          <Label>{translate("No")}</Label>
        </div>
        <div>
          <Input
            type="radio"
            value={true}
            id={"reason-1-" + id}
            onClick={() => {
              setBody([true, (body[1] || null)])
              setIsDirty(true)
            }}
            checked={body[0]}
            disabled={isDisabled}
          />
          <Label>{translate("Yes")}</Label>
        </div>
        {
          !!body[0] && (
            <div className={"margin-left"}>
              <div>
                <Input
                  type="radio"
                  value={false}
                  id={"reason-01-" + id}
                  onClick={() => {
                    setBody([true, false])
                    setIsDirty(true)
                  }}
                  checked={body[1] === false}
                  disabled={isDisabled}
                />
                <Label>{translate("EssentialSubjects")}</Label>
              </div>
              <div>
                <Input
                  type="radio"
                  value={true}
                  id={"reason-02-" + id}
                  onClick={() => {
                    setBody([true, true])
                    setIsDirty(true)
                  }}
                  checked={body[1] === true}
                  disabled={isDisabled}
                />
                <Label>{translate("ImportantSubjects")}</Label>
              </div>
            </div>
          )
        }
      </FormGroup>
    )
  }

  // Per gestire in fretta
  if (id === 32 || id === 33) {
    content = (
      <FormGroup>
        <div>
          <Input
            type="radio"
            value={false}
            onClick={() => {
              setBody([false, []])
              setIsDirty(true)
            }}
            checked={body[0] === false}
            disabled={isDisabled}
          />
          <Label>{translate("Undetectable")}</Label>
        </div>
        <div>
          <Input
            type="radio"
            value={true}
            onClick={() => {
              setBody([true, [body[1]]])
              setIsDirty(true)
            }}
            checked={body[0]}
            disabled={isDisabled}
          />
          <Label>{translate("Detectable")}</Label>
        </div>
        {
          !!body[0] && (
            <div className={"margin-left"}>
              {choiche?.map((ch, index) => {
                return (
                  <div key={"reason-" + id + "-" + index}>
                    <Input
                      type="radio"
                      value={ch.id}
                      id={"reason-" + id + "-" + index}
                      onClick={() => {
                        setBody([true, [parseInt(ch.id)]])
                        setIsDirty(true)
                      }}
                      checked={body?.[1]?.[0] === parseInt(ch.id)}
                      disabled={isDisabled}
                    />
                    <Label>{ch.description}</Label>
                  </div>
                )
              })}
              {/*<div>*/}
              {/*  <Input*/}
              {/*    type="radio"*/}
              {/*    value={false}*/}
              {/*    onClick={() => {*/}
              {/*      setBody([true, false])*/}
              {/*      setIsDirty(true)*/}
              {/*    }}*/}
              {/*    checked={body[1] === false}*/}
              {/*    disabled={isDisabled}*/}
              {/*  />*/}
              {/*  <Label>{translate("No")}</Label>*/}
              {/*</div>*/}
              {/*<div>*/}
              {/*  <Input*/}
              {/*    type="radio"*/}
              {/*    value={true}*/}
              {/*    onClick={() => {*/}
              {/*      setBody([true, true])*/}
              {/*      setIsDirty(true)*/}
              {/*    }}*/}
              {/*    checked={body[1] === true}*/}
              {/*    disabled={isDisabled}*/}
              {/*  />*/}
              {/*  <Label>{translate("Yes")}</Label>*/}
              {/*</div>*/}
            </div>
          )
        }
      </FormGroup>
    )
  }

  // Per gestire in fretta
  if (id === 34) {
    content = (
      <FormGroup>
        <div>
          <Input
            type="radio"
            value={false}
            onClick={() => {
              setBody([false, []])
              setIsDirty(true)
            }}
            checked={body[0] === false}
            disabled={isDisabled}
          />
          <Label>{translate("Undetectable")}</Label>
        </div>
        <div>
          <Input
            type="radio"
            value={true}
            onClick={() => {
              setBody([true, (body[1] || null)])
              setIsDirty(true)
            }}
            checked={body[0]}
            disabled={isDisabled}
          />
          <Label>{translate("Detectable")}</Label>
        </div>
        {/*{*/}
        {/*  !!body[0] && content*/}
        {/*}*/}
        {
          !!body[0] && (
            <Input
              type={"number"}
              name={"reason-" + id}
              id={"reason-" + id}
              defaultValue={body[1] || 0}
              onBlur={(blurEvent) => {
                let value = blurEvent?.target?.value || null;
                setBody([true, parseFloat(value)])
                setIsDirty(true)
              }}
              disabled={isDisabled}
            />
          )
        }
      </FormGroup>
    )
  }

  return (
    <div>
      <div className={"space-between"}>
        <div>

          {content}
        </div>
        {/*<div className={"perimeter-question-note"}>*/}
        {/*  <span>Note</span>*/}
        {/*  <Input*/}
        {/*    type={"textarea"}*/}
        {/*    row={32}*/}
        {/*    name={"reason-note-" + id}*/}
        {/*    id={"reason-note-" + id}*/}
        {/*    // placeholder={translate("Insert") + " " + ch}*/}
        {/*    className={""}*/}
        {/*    defaultValue={""} // TODO*/}
        {/*    onBlur={(blurEvent) => {*/}
        {/*      let text = blurEvent?.target?.value || null;*/}
        {/*      showlog('note text: ', text);*/}


        {/*    }}*/}
        {/*    disabled={isDisabled}*/}
        {/*  />*/}
        {/*</div>*/}
      </div>
      <div className={"perimeter-question-note"}>
        <span>Note</span>
        <Input
          type={"textarea"}
          row={32}
          name={"reason-note-" + id}
          id={"reason-note-" + id}
          // placeholder={translate("Insert") + " " + ch}
          className={"perimeter-note-input-field"}
          defaultValue={note}
          onBlur={(blurEvent) => {
            let text = blurEvent?.target?.value || null;
            // showlog('note text: ', text);
            setNote(text)
            setIsDirty(true)
          }}
          disabled={isDisabled}
        />
      </div>
      {
        !isDisabled &&
        isDirty &&
        <span className="float-left perimeter-question-list-inputs">
						<ActionButton
              buttonText={"Salva"}
              className={canSave() ? "" : "disabled"}
              promise={() => {
                setWaitingForSave(true)

                // processBodyToSend(body) // TODO Commentare
                // return Promise.resolve()

                if (canSave()) {

                  if (!checkQuestionAttachments(props.question, body)) {
                    if (typeof props.onError === "function")
                      return Promise.reject(translate("MandatoryAttachment"));
                  }

                  return savePerimeterQuestion(evaluationId, id, {
                    value: processBodyToSend(body),
                    note: note
                  })
                }
                // if (true) return savePerimeterQuestion(evaluationId, id, processBodyToSend(body))
                else return Promise.reject(translate("Questions to be completed"))
              }}
              onResult={result => {
                setIsDirty(false)
                setWaitingForSave(false)
                if (typeof props.updateQuestion === "function") props.updateQuestion(id, {value: body, note: note});
              }}
              onError={(error) => {
                setWaitingForSave(false)
                if (typeof props.onError === "function") props.onError(error);
              }}
            />
							</span>
      }
    </div>
  )
}
